<template>
  <div class="input-container">
    <v-card flat>
      <v-card-text>
        <div v-if="!showHospitalProfile">
          <v-row>
            <v-col cols="12" md="2" sm="6">
              <label for class="fz-10px">Search by Name</label>
              <div class="search-div position-relative">
                <input
                  class="form-control"
                  placeholder="Name"
                  v-model="searchParameter.search_text"
                  @input="debounceSearch(true)"
                />
                <div
                  v-if="searchParameter.search_text !== ''"
                  class="search-svg position-absolute"
                  @click="clearSearch()"
                >
                  <crossSVG />
                </div>
              </div>
            </v-col>
            <div class="col-md-3 col-12">
              <div class="position-relative">
                <label for="">Per page</label
                ><select
                  v-model="recordPerPage"
                  name=""
                  id=""
                  class="form-control"
                  @change="debounceSearch(true)"
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="100">100</option></select
                ><span class="drop-icon"
                  ><i
                    aria-hidden="true"
                    class="
                      v-icon
                      mdi mdi-menu-down
                      theme--light
                      position-absolute
                    "
                  ></i
                ></span>
              </div>
            </div>

            <div class="col-md-3 col-12">
              <div class="position-relative">
                <label>Filter by status</label
                ><select
                  v-model="isCompleted"
                  class="form-control"
                  @change="debounceSearch(true)"
                >
                  <option value="ALL">All</option>
                  <option value="PENDING">Pending</option>
                  <option value="APPROVED">Approved</option>
                  <option value="REJECT">Rejected</option>
                  <!-- <option value="NOT_UPLOADED">Not Uploaded</option> -->
                  </select
                ><span class="drop-icon"
                  ><i
                    aria-hidden="true"
                    class="
                      v-icon
                      mdi mdi-menu-down
                      theme--light
                      position-absolute
                    "
                  ></i
                ></span>
              </div>
            </div>
          </v-row>

          <loader v-if="showLoader"></loader>

          <v-row>
            <v-col cols="12" class="mt-2">
              <div class="table-div overflow-auto">
                <table
                  class="table userlistTable table-width small-table-width"
                >
                  <thead>
                    <tr class="table-success">
                      <th scope="col">Name of Hospital</th>
                      <th scope="col">Owner Name</th>
                      <th scope="col">Owner Contact Number</th>
                      <th scope="col">Hospital Contact Number</th>
                      <th scope="col">Hospital Location</th>
                      <!-- <th scope="col" class="small-min-width-120">
                        Centre Type
                      </th> -->
                      <th scope="col">Status</th>
                      <th scope="col">Requested On</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(center, index) in centerList" :key="index">
                      <!-- Centre Name -->
                      <td>
                        <div>
                          {{
                            center.center_id.general &&
                            center.center_id.general.name
                          }}
                        </div>
                      </td>
                      <td>
                        <div>
                          {{ center.created_by && center.created_by.full_name }}
                        </div>
                      </td>
                      <!-- Contact No -->
                      <td>
                        <div>
                          {{ center.created_by && center.created_by.mobile }}
                        </div>
                      </td>
                      <td>
                        <div>
                          {{
                            center &&
                            center.center_id &&
                            center.center_id.general.contact_number
                          }}
                        </div>
                      </td>
                      <!-- Location -->
                      <!-- <td></td> -->
                      <td
                        v-if="
                          center &&
                          center.center_id &&
                          center.center_id.general.address &&
                          center.center_id.general.address.city
                        "
                      >
                        {{ center.center_id.general.address.city }}
                      </td>

                      <td>
                        <span
                          v-if="center.current_document_status == 'PENDING'"
                        >
                          <span class="badge badge-warning">Pending</span>
                          <InfoIconSVG
                            v-if="checkRequestWasRejected(center.histories)"
                            v-c-tooltip.hover.click="
                              'This request was previously rejected. View log to see more details.'
                            "
                            class="info-icon"
                          />
                        </span>
                        <span
                          class="badge badge-success"
                          v-else-if="
                            center.current_document_status == 'APPROVED'
                          "
                          >Approved</span
                        >
                        <!-- <span
                          class="badge badge-danger"
                          v-else-if="
                            center.current_document_status == 'NOT_UPLOADED'
                          "
                          >Not Uploaded</span
                        > -->
                        <span class="badge badge-danger" v-else>Rejected</span>
                      </td>

                      <td>{{ center.createdAt | formatDate }}</td>

                      <td class="action-div small-table-padding">
                        <div
                          class="
                            d-flex
                            justify-content-center
                            small-table-padding
                            align-center
                          "
                        >
                          <div
                            v-if="
                              center.current_document_status !== 'NOT_UPLOADED'
                            "
                            class="my-3 mr-2"
                          >
                            <CButton
                              class="text-uppercase view-log-btn"
                              block
                              variant="outline"
                              color="success"
                              v-if="
                                permissions.includes(
                                  'CAN_VIEW_LOG_HOSPITAL_LISTING'
                                )
                              "
                              @click="openCenterLogModal(center)"
                              >View Log</CButton
                            >
                          </div>
                          <div class="my-3">
                            <div
                              v-if="
                                center.current_document_status === 'PENDING'
                              "
                            >
                              <CButton
                                class="text-uppercase"
                                block
                                variant="outline"
                                color="success"
                                v-if="
                                  permissions.includes(
                                    'CAN_VERIFY_LOG_HOSPITAL_LISTING'
                                  )
                                "
                                @click="verifyCenter('Verify', center)"
                                >Verify</CButton
                              >
                            </div>
                            <div
                              v-if="
                                center.current_document_status === 'APPROVED'
                              "
                            >
                              <CButton
                                block
                                variant="outline"
                                color="success"
                                @click="verifyCenter('View', center)"
                                v-if="
                                  permissions.includes(
                                    'CAN_VIEW_DOCUMENT_CENTER_APPROVAL'
                                  )
                                "
                                >View</CButton
                              >
                            </div>

                            <!-- <div
                              v-if="
                                center.current_document_status ===
                                'NOT_UPLOADED'
                              "
                            >
                              <CButton
                                block
                                variant="outline"
                                color="danger"
                                @click="verifyCenter('Reject', center)"
                                v-if="
                                  permissions.includes(
                                    'CAN_APPROVE_REJECT_CENTER_APPROVAL'
                                  )
                                "
                                >Reject</CButton
                              >
                            </div> -->
                            <div
                              v-if="center.current_document_status === 'REJECT'"
                            >
                              <CButton
                                block
                                variant="outline"
                                color="danger"
                                v-if="
                                  permissions.includes(
                                    'CAN_VIEW_DOCUMENT_CENTER_APPROVAL'
                                  )
                                "
                                @click="verifyCenter('Reason', center)"
                                >Reason</CButton
                              >
                            </div>
                          </div>

                          <div class="action-div small-table-padding">
                            <div>
                              <CDropdown
                                color="link"
                                size="lg"
                                :caret="false"
                                class="dropdowndocbox"
                              >
                                <template #toggler-content>
                                  <verticalDotsSVG />
                                </template>
                                <CDropdownItem v-if="
                                    permissions.includes(
                                    'CAN_VIEW_DETAILS_HOSPITAL_APPROVAL'
                                    )
                                " 
                                @click="getViewDetails(center)"
                                  >View Details</CDropdownItem
                                >
                                <CDropdownItem>Call</CDropdownItem>
                                <CDropdownItem>Message</CDropdownItem>
                                <CDropdownItem>Email</CDropdownItem>
                                <!-- <CDropdownItem>Deactivate</CDropdownItem> -->
                              </CDropdown>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr></tr>
                  </tbody>
                  <tbody v-if="isEmpty">
                    <tr>
                      <td colspan="8">
                        <h2 class="text-center">No Data Found</h2>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-col>
          </v-row>
          <pagination
            v-if="!isEmpty"
            class="mx-0 mob-t-center pagination-block"
            :recordPerPage="recordPerPage"
            :total="total"
            @changePage="changePage"
          />
          <div v-if="showPdf">
            <v-dialog v-model="showPdf" width="500" persistent id="view-box">
              <pdf-html
                title="Profile QR"
                subject="shareLink"
                ref="pdfView"
                :identifier="centerId"
                :HideDownloadButton="true"
                :HidePrintButton="true"
                @close="showPdf = false"
                :buttons="[]"
                :queryParameters="urlQueryParam"
                :reCompile="true"
              ></pdf-html>
            </v-dialog>
          </div>
        </div>
        <center-log-modal
          v-if="showCenterLogModal"
          :showCenterLogModal="showCenterLogModal"
          :centerData="centerData"
          @close="closeModal()"
          @openViewDetails="openViewDetails"
        ></center-log-modal>
        <center-approval-modal
          v-if="showCenterApprovalModal"
          :showCenterApprovalModal="showCenterApprovalModal"
          :statusType="statusType"
          :centerData="centerData"
          @close="closeModal()"
          @refreshList="getCenterList()"
        ></center-approval-modal>
        <hospitalProfileSummaryDetails
          v-if="showHospitalProfile"
          @close="closeProfile()"
          :centerId="userId"
        ></hospitalProfileSummaryDetails>
        <image-preview
          @close="closeImageModal"
          v-if="openImageModal"
          :openImageModal="openImageModal"
          :source="fileUrl"
          :fileArcheType="fileArcheType"
        ></image-preview>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import config from "@/config.js";
import formats from "@/formats";
import { pickSvg } from "@/views/SVG";
import InfoIconSVG from "@/views/SVG/InfoIconSVG";
const imagePreview = () => import("@/components/modals/imagePreview.vue");
const pagination = () => import("@/views/common/Pagination");
const loader = () => import("@/components/loader.vue");
import debounce from "lodash/debounce";
import Datepicker from "v-calendar/lib/components/date-picker.umd";
import { mapGetters } from "vuex";
import { bus } from "@/main.js";
const centerLogModal = () =>
  import("@/components/ApprovalCenters/centerLogModal.vue");
const centerApprovalModal = () =>
  import("@/components/ApprovalCenters/centerApprovalModal.vue");
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();
export default {
  components: {
    hospitalProfileSummaryDetails: () =>
      import(
        "@/views/dashboardNew/userListing/hospitalProfileSummaryDetails.vue"
      ),
    ...pickSvg("messageSVG", "phoneSVG", "emailSVG", "crossSVG"),
    "image-preview": imagePreview,
    pagination,
    InfoIconSVG,
    loader,
    Datepicker,
    PdfHtml: () => import("@/components/PdfHtml"),
    "center-log-modal": centerLogModal,
    "center-approval-modal": centerApprovalModal,
  },
  data() {
    return {
      showPdf: false,
      dayJS,
      formats,
      recordPerPage: 10,
      currentPage: 1,
      search: "",
      status: "ALL",
      centerList: [],
      role: "hospital",
      total: "",
      perPageOptions: [
        { perPage: 10, value: 10 },
        { perPage: 20, value: 20 },
        { perPage: 30, value: 30 },
        { perPage: 50, value: 50 },
        { perPage: 100, value: 100 },
      ],
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00",
        },
        end: {
          timeAdjust: "23:59:59",
        },
      },
      statusOptions: [
        { name: "All", value: "ALL" },
        { name: "Pending", value: "PENDING" },
        { name: "Approved", value: "APPROVED" },
        { name: "Rejected", value: "REJECT" },
        // { name: "Not Uploaded", value: "NOT_UPLOADED" },
      ],
      showLoader: false,
      isEmpty: false,
      openImageModal: false,
      fileUrl: "",
      fileArcheType: "",
      centerData: {},
      showCenterApprovalModal: false,
      statusType: "",
      showCenterLogModal: false,
      joinOnDateRange: { start: "", end: "" },
      isCompleted: "ALL",
      showHospitalProfile: false,
      searchParameter: {
        search_text: "",
        // number: "",
        // location: "",
        // owner_name: "",
        // owner_mobile: "",
        // is_verified: "",
      },
    };
  },

  computed: {
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },
  mounted() {
    this.debounceSearch();
  },

  filters: {
    formatDate: (date) => {
      return dayJS(date).format("DD/MM/YYYY");
    },
  },
  methods: {
    resetJoiningDate() {
      this.joinOnDateRange = { start: "", end: "" };
      this.debounceSearch(true);
    },
    closeProfile() {
      this.showHospitalProfile = false;
    },
    openViewDetails(history) {
      this.openImageModal = true;
      this.closeModal();
      this.fileUrl = history.registration_proof_image_url;
      this.fileArcheType = "Certificate";
    },
    getViewDetails(centerData) {
      this.userId = centerData.center_id._id;
      this.showHospitalProfile = true;
    },

    clearSearch() {
      this.searchParameter.search_text = "";
      this.debounceSearch(true);
    },
    changeProfile() {
      this.debounceSearch(true);
    },
    dateChange() {
      this.debounceSearch(true);
    },
    changePage(page) {
      this.currentPage = page.currentPage;
      this.debounceSearch();
    },
    closeImageModal() {
      this.openImageModal = false;
    },
    closeModal() {
      this.showCenterLogModal = false;
      this.showCenterApprovalModal = false;
    },

    openCenterLogModal(centerData) {
      this.centerData = centerData;
      this.showCenterLogModal = true;
    },
    verifyCenter(type, centerData) {
      this.centerData = centerData;
      this.showCenterApprovalModal = true;
      this.statusType = type;
    },
    getCenterList() {
      this.showLoader = true;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        search_text: this.searchParameter.search_text,
        status: this.isCompleted,
        center_type: "hospital",
      };

      let url = `${config.BASE_URL}api/v2/admin/centers`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.showLoader = false;
          if (response.body.data.list.length) {
            this.isEmpty = false;
            this.centerList = response.body.data.list;

            this.totalPage = response.body.data.total;
            this.total = response.body.data.count;
          } else {
            this.centerList = [];
            this.isEmpty = true;
          }
        }
      });
    },
    downloadCsv() {
      this.showLoader = true;
      let params = {
        page: this.currentPage,
        records_per_page: this.recordPerPage,
        search_text: this.searchParameter.search_text,
        is_complete: this.isCompleted,
        // joined_on_from:
        //   this.joinOnDateRange.start === ""
        //     ? ""
        //     : new Date(this.joinOnDateRange.start).toISOString(),
        // joined_on_to:
        //   this.joinOnDateRange.end === ""
        //     ? ""
        //     : new Date(this.joinOnDateRange.end).toISOString(),
        // mobile: this.searchParameter.number,
        // city: this.searchParameter.location,
      };
      let url = `${config.BASE_URL}api/v2/admin/center-list-csv/${this.role}`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.showLoader = false;
          const data = response.data.data;
          this.download(data.fileName, data.csv);
        }
      });
    },
    download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    checkRequestWasRejected(histories) {
      let truth = false;
      histories.forEach((history) => {
        if (history.current_document_status == "REJECT") {
          truth = true;
        }
      });
      return truth;
    },
    debounceSearch: debounce(function (pageReset = false) {
      if (pageReset) {
        bus.$emit("PAGE_CHANGE");
        this.currentPage = 1;
      }

      this.getCenterList();
    }, 500),
  },
};
</script>
<style scoped>
.verify,
.view-log {
  height: 22px !important;
  font-size: 12px !important;
}
.table-div {
  height: 100vh;
}

.view-log-btn {
  white-space: nowrap;
}
</style>